module.exports = __webpack_public_path__ + "img/27_66.1f7eb17e.png";